export default "__VITE_ASSET__DpcRdVwG__"